import styled from 'styled-components'

export const PublishedAndReadingTimeWrapper = styled.div`
  .sora {
    font-family: 'Sora';
  }
`
